import React from "react";
import { Box, Image } from "@chakra-ui/react";
import "../styles/cart.css";
import image from "../assets/landing.png";

const LandingImage = () => (
  <Box position="relative" w="100%">
    <Box position="relative" borderRadius="3xl" overflow="hidden">
      <Image src={image} alt="Payinapo preview" w="100%" display="block" />
    </Box>
  </Box>
);

export default LandingImage;
